// assets
import { KyberNetwork } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  traffic: KyberNetwork,
};

// ==============================|| MENU ITEMS - TRAFFIC ||============================== //

const traffic: NavItemType = {
  id: "group-traffic",
  title: "Traffic",
  icon: icons.traffic,
  type: "group",
  children: [
    {
      id: "traffic-monitoring",
      title: "Traffic Monitoring",
      type: "item",
      url: "/traffic",
      icon: icons.traffic,
    },
  ],
};

export default traffic;
